/* eslint-disable max-len */
export default {
  // NAVIGATION MENU
  getNavigationMenu: (state) => state.profileSettings.navigationMenu,
  getReturnUrl: (state) => state.returnUrl,
  // CLIENT ACCOUNT
  getclientAccount: (state) => state.clientAccount,
  getClientAuthorityUrl: (state) => state.profileSettings.authorityUrl,
  getclientAccountEmail: (state) => state.clientAccount.email,
  getclientAccountAutoRenewingEnabled: (state) => state.clientAccount.autoRenewingEnabled,
  getclientAccountIsLicenseManager: (state) => state.clientAccount.isLicenseManager,
  getClientAccountFetched: (state) => state.clientAccountFetched,
  getAreSubscriptionsValid: (state) => state.areSubscriptionsValid,

  getPaymentMethodId: (state) => state.paymentMethodId,


  // CLIENT SITE LICENSES
  getClientSiteLicenses: (state) => state.clientAccount.siteLicenses,
  getClientSiteLicenseUsers: (state) => state.clientAccount.siteLicenseUsers,
  getClientSelectedSiteLicenseId: (state) => state.licenseSettings.selectedLicenseId,
  getClientSelectedSiteLicenseName: (state) => state.licenseSettings.selectedLicenseName,
  getClientSiteLicenseMembershipsTotal: (state) => state.licenseSettings.membershipsTotal,
  getClientSiteLicenseMembershipsUsed: (state) => state.licenseSettings.membershipsUsed,

  getClientSiteLicensePaginationCurrentPage: (state) => state.licenseSettings.pagination.currentPage,
  getClientSiteLicensePaginationTotalPages: (state) => state.licenseSettings.pagination.totalPages,

  getClientSiteLicenseUsersPaginationCurrentPage: (state) => state.licenseUsersSettings.pagination.currentPage,
  getClientSiteLicenseUsersPaginationTotalPages: (state) => state.licenseUsersSettings.pagination.totalPages,
  getClientSiteLicenseUsersPaginationTotalCount: (state) => state.licenseUsersSettings.pagination.totalCount,

  getClientSiteLicenseUsersAddMemberInformationFirstName: (state) => state.licenseUsersSettings.addMemberInformation.firstName,
  getClientSiteLicenseUsersAddMemberInformationLastName: (state) => state.licenseUsersSettings.addMemberInformation.lastName,
  getClientSiteLicenseUsersAddMemberInformationEmailAddress: (state) => state.licenseUsersSettings.addMemberInformation.emailAddress,

  getClientSelectedLicenseUserId: (state) => state.licenseUsersSettings.selectedLicenseUserId,

  getClientSiteLicenseUserFilterValue: (state) => state.licenseUsersSettings.filters.params.email,

  // CLIENT SITE LICENSE INVITATIONS
  getClientSiteLicenseInvitations: (state) => state.clientAccount.siteLicenseInvitations,

  // CLIENT SUBSCRIPTIONS
  getClientActiveSubscriptions: (state) => state.clientAccount.activeSubscriptions,
  getActiveSubscriptionsSettingsCurrentTab: (state) => state.activeSubscriptionsSettings.navigation.currentTab,
  getClientActiveSubscriptionsPaginationCurrentPage: (state) => state.activeSubscriptionsSettings.pagination.currentPage,
  getClientActiveSubscriptionsPaginationTotalPages: (state) => state.activeSubscriptionsSettings.pagination.totalPages,

  // CLIENT EXPIRED SUBSCRIPTIONS
  getClientExpiredSubscriptions: (state) => state.clientAccount.expiredSubscriptions,
  getClientExpiredSubscriptionsPaginationCurrentPage: (state) => state.expiredSubscriptionsSettings.pagination.currentPage,
  getClientExpiredSubscriptionsPaginationTotalPages: (state) => state.expiredSubscriptionsSettings.pagination.totalPages,

  // CLIENT PAYMENTS
  getClientPaymentsHistory: (state) => state.clientAccount.paymentInfo.paymentsHistory,
  getClientPaymentsPaginationCurrentPage: (state) => state.paymentsSettings.pagination.currentPage,
  getClientPaymentsPaginationTotalPages: (state) => state.paymentsSettings.pagination.totalPages,
  getClientPaymentsPaginationTotalCount: (state) => state.paymentsSettings.pagination.totalCount,
  getClientPaymentsPaginationPageSize: (state) => state.paymentsSettings.pagination.pageSize,

  getClientPaymentInfoBraintreeClientToken: (state) => state.clientAccount.paymentInfo.braintreeClientToken,
  getClientPaymentInfoStripeClientToken: (state) => state.clientAccount.paymentInfo.stripeClientToken,
  getClientSelectedPaymentInfo: (state) => state.clientAccount.paymentInfo.selectedPaymentInfo,
  getClientPaymentInfos: (state) => state.clientAccount.paymentInfo.paymentInfos,
  getAddPaymentMethod: (state) => state.paymentInfosSettings.addPaymentMethod,
  getEditPaymentMethod: (state) => state.paymentInfosSettings.editPaymentMethod,
  getClientPaymentInfosPaginationCurrentPage: (state) => state.paymentInfosSettings.pagination.currentPage,
  getClientPaymentInfosPaginationTotalPages: (state) => state.paymentInfosSettings.pagination.totalPages,
  getClientPaymentInfosPaginationTotalCount: (state) => state.paymentInfosSettings.pagination.totalCount,
  getClientPaymentInfosPaginationPageSize: (state) => state.paymentInfosSettings.pagination.pageSize,

  // ISLOADING SPINNER
  getIsLoading: (state) => state.isLoading,

  // ADD EDIT PAYMENT METHOD IS LOADING
  getAddEditPaymentMethodIsLoading: (state) => state.addEditPaymentMethodIsLoading,

  // MAIN IS LOADING
  getMainIsLoading: (state) => state.mainIsLoading,

  // PORTA MAIN IS LOADING
  getPortaMainIsLoading: (state) => state.portaMainIsLoading,

  // PAGE HEIGHT
  getPageHeight: (state) => state.pageHeight,

  // GET SHOW CANCEL MODAL
  getConfirmationModal: (state) => state.confirmationModal,
  getConfirmationModalType: (state) => state.confirmationModal.type,
  getShowConfirmationModal: (state) => state.confirmationModal.show,
  getConfirmationModalSubscription: (state) => state.confirmationModal.subscription,

  // GET SHOW ADD MEMBER MODAL
  getShowAddMemberModal: (state) => state.showAddMemberModal,
  getShowContactSupportModal: (state) => state.showContactSupportModal,
  getContactSupportButtonDisabled: (state) => state.contactSupportButtonDisabled,

  // GET PROFILE LANGUAGE
  getLanguage: (state) => state.profileSettings.language,

  // GET IS PORTA
  getIsPorta: (state) => state.profileSettings.isPorta,

  getLicenseSelected: (state) => state.licenseSettings.isLicenseSelected,

  // GET CLIENT GIFTS & VOUCHERS
  getClientGifts: (state) => state.clientAccount.gifts,
  getSelectedGiftId: (state) => state.giftsSettings.selectedGiftId,

  getClientGiftsPaginationCurrentPage: (state) => state.giftsSettings.pagination.currentPage,
  getClientGiftsPaginationTotalPages: (state) => state.giftsSettings.pagination.totalPages,
  getClientGiftsPaginationTotalCount: (state) => state.giftsSettings.pagination.totalCount,
  getClientGiftsPaginationPageSize: (state) => state.giftsSettings.pagination.pageSize,

  getClientVouchers: (state) => state.clientAccount.vouchers,
  getSelectedVoucherId: (state) => state.vouchersSettings.selectedVoucherId,
  getClientVouchersPaginationCurrentPage: (state) => state.vouchersSettings.pagination.currentPage,
  getClientVouchersPaginationTotalPages: (state) => state.vouchersSettings.pagination.totalPages,
  getClientVouchersPaginationTotalCount: (state) => state.vouchersSettings.pagination.totalCount,
  getClientVouchersPaginationPageSize: (state) => state.vouchersSettings.pagination.pageSize,


  getClientExternalVouchers: (state) => state.clientAccount.externalVouchers,
  getSelectedExternalVoucherId: (state) => state.externalVouchersSettings.selectedVoucherId,
  getClientExternalVouchersPaginationCurrentPage: (state) => state.externalVouchersSettings.pagination.currentPage,
  getClientExternalVouchersPaginationTotalPages: (state) => state.externalVouchersSettings.pagination.totalPages,
  getClientExternalVouchersPaginationTotalCount: (state) => state.externalVouchersSettings.pagination.totalCount,
  getClientExternalVouchersPaginationPageSize: (state) => state.externalVouchersSettings.pagination.pageSize,

  getLanguagesDropdown: (state) => state.languagesDropdown,
  getCurrentLanguage: (state) => state.currentLanguage,
}
